import React, { useState, useEffect } from "react";
import { Link,useNavigate } from "react-router-dom";
import LogoUploader from "../components/LogoUploader";
import api from "../api/auth";
import SuccessModal from "../components/SuccessModal";
import { useAuth } from "../context/AuthContext";

export function Settings() {
  const navigate = useNavigate();
  
  const [profilePic, setProfilePic] = useState("");
  const [completion, setCompletion] = useState(0);
const [showSuccessModal, setShowSuccessModal] =
  useState(false);
const { user, logout } = useAuth();
const [loggingOut, setLoggingOut] =
  useState(false);
  const [form, setForm] = useState({
    businessName: "",
    gstNumber: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "India",
    pincode: "",
    logoUpload: "",
   // ✅ NEW
  invoiceTemplate: "modern",
  });

  const [loading, setLoading] = useState(false);
  const [mobileMenu, setMobileMenu] =
  useState(false);
  const [error, setError] = useState("");

  // =========================
  // FETCH USER (PROFILE PIC)
  // =========================
  const fetchUser = async () => {
    try {
      // const res = await fetch("/api/user");
      const res = await api.get("/api/user");
      // const data = await res.json();
      const data = await res.data;

      if (data) {
        setProfilePic(data.picture || "");
      }
    } catch (err) {
      console.log("Failed to fetch user");
    }
  };
const handleLogout = async () => {

  try {

    setLoggingOut(true);

    await logout();

    navigate("/");

  } catch (err) {

    console.error(err);

    setLoggingOut(false);
  }
};
  //fethbusiness profile data
const fetchBusiness = async () => {
  try {
    // const res = await fetch("/api/user/business");
    const res = await api.get("/api/user/business");
    // const data = await res.json();
    const data = await res.data;
    const b = data.business;

    if (b) {

const updatedForm = {
  businessName: b.name || "",
  gstNumber: b.gstin || "",
  phone: b.phone || "",
  email: b.email || "",
  address: b.address || "",
  city: b.city || "",
  state: b.state || "",
  country: b.country || "India",
  pincode: b.pincode || "",
  logoUpload: b.logoUpload || "",

  // ✅ template
  invoiceTemplate: b.invoiceTemplate || "modern",
};

  setForm(updatedForm);

  // ✅ calculate completion from DB data
  setCompletion(calculateCompletion(updatedForm));

  setPreview(b.logoUpload || "");
}
  } catch (err) {
    console.log("Failed to load business", err);
  }
};
  useEffect(() => {
    fetchUser();
     fetchBusiness();
  }, []);

  // =========================
  // PROFILE COMPLETION
  // =========================
  const calculateCompletion = (updated) => {
    const fields = [
      "businessName",
      "gstNumber",
      "phone",
      "email",
      "address",
      "city",
      "state",
      "pincode",
      "logoUpload",
      "invoiceTemplate"
    ];

    const filled = fields.filter((k) => updated[k]?.trim()).length;
    return Math.round((filled / fields.length) * 100);
  };

  // =========================
  // HANDLE INPUT
  // =========================
  const handleChange = (e) => {
    const updated = { ...form, [e.target.name]: e.target.value };
    setForm(updated);
    setCompletion(calculateCompletion(updated));
  };

  // =========================
  // FETCH GST DATA
  // =========================
  const fetchGST = async () => {
    if (!form.gstNumber) {
      setError("Please enter GST number");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const API_KEY = process.env.REACT_APP_GST_API_KEY;

      const res = await fetch(
        `https://api.gstapi.info/gstin/${form.gstNumber}?key=${API_KEY}`
      );

      const data = await res.json();

      if (data && data.data) {
        const updated = {
          ...form,
          businessName: data.data.legal_name || "",
          address: data.data.principal_place_address || "",
          city: data.data.principal_place_address?.split(",")[1]?.trim() || "",
          state: data.data.principal_place_address?.split(",")[2]?.trim() || "",
        };

        setForm(updated);
        setCompletion(calculateCompletion(updated));
      } else {
        setError("GST not found or invalid");
      }
    } catch (err) {
      setError("Failed to fetch GST details but you can still add manually");
    }

    setLoading(false);
  };
   // LOCAL PREVIEW (instant UI)
  const [preview, setPreview] = useState("");

 const handleLogoUpload = (url) => {
    // setForm((prev) => ({
    //   ...prev,
    //   logoUpload: url,

    // }));
    const updated = {
    ...form,
    logoUpload: url,
  };
      setForm(updated);

  // ✅ update profile %
  setCompletion(calculateCompletion(updated));
          setPreview(url); // show instantly below fields
          

  };
  // =========================
  // SAVE SETTINGS (dummy)
  // =========================
//   const saveSettings = async () => {
//   try {
//     const payload = {
//       businessName: form.businessName,
//       gstNumber: form.gstNumber,
//       phone: form.phone,
//       email: form.email,
//       address: form.address,
//       city: form.city,
//       state: form.state,
//       country: form.country,
//       pincode: form.pincode,
//       logoUpload: form.logoUpload,
//       invoiceTemplate: form.invoiceTemplate,
//     };

//     const res = await fetch("/api/user/business", {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();

//     if (!res.ok) throw new Error(data.message || "Failed to save");

//     alert("Settings saved successfully!");
//     console.log("Saved to DB:", data);
//   } catch (err) {
//     console.error(err);
//     alert("Failed to save settings");
//   }
// };

const saveSettings = async () => {
  try {
    const payload = {
      businessName: form.businessName,
      gstNumber: form.gstNumber,
      phone: form.phone,
      email: form.email,
      address: form.address,
      city: form.city,
      state: form.state,
      country: form.country,
      pincode: form.pincode,
      logoUpload: form.logoUpload,
      invoiceTemplate: form.invoiceTemplate,
    };

    const res = await api.put(
      "/api/user/business",
      payload
    );

    // alert("Settings saved successfully!");
    // console.log("Saved to DB:", res.data);
setShowSuccessModal(true);
  } catch (err) {
    console.error(err);
    alert(
      err.response?.data?.message ||
      "Failed to save settings"
    );
  }
};

  return (
    <>
      <style>{`
body{
  margin:0;
  font-family:'Sora',sans-serif;
  background:#f5f4f0;
  overflow-x:hidden;
}

*{
  box-sizing:border-box;
}

.shell{
  display:flex;
  min-height:100vh;
}

/* =========================
   SIDEBAR
========================= */

.sidebar{
  width:240px;
  background:#2d2b69;
  color:white;
  position:fixed;
  top:0;
  left:0;
  height:100vh;
  padding:24px 12px;
  z-index:1000;
  transition:transform 0.3s ease;
  display:flex;
  flex-direction:column;
}

.logo{
  padding:0 55px 20px;
  border-bottom:1px solid rgba(255,255,255,0.1);
  margin-bottom:20px;
}

.logo-title{
  font-size:22px;
  font-weight:700;
}

.logo-sub{
  font-size:10px;
  opacity:0.5;
  margin-top:4px;
  letter-spacing:1px;
  text-transform:uppercase;
}

.sidebar-nav{
  flex:1;
}

.nav-item{
  display:flex;
  align-items:center;
  gap:10px;
  padding:11px 12px;
  border-radius:10px;
  margin-bottom:5px;
  color:rgba(255,255,255,0.7);
  text-decoration:none;
  transition:0.2s;
  font-size:13px;
  font-weight:500;
}

.nav-item:hover,
.nav-item.active{
  background:rgba(255,255,255,0.12);
  color:white;
}

/* =========================
   MOBILE MENU
========================= */

.mobile-menu-btn{
  display:none;
}

.mobile-overlay{
  display:none;
}

/* =========================
   MAIN
========================= */

.main{
  flex:1;
  margin-left:240px;
  padding:40px;
  width:100%;
}

.page-title{
  font-size:32px;
  font-weight:700;
  margin-bottom:5px;
}

.page-sub{
  color:#777;
  margin-bottom:25px;
}

.card{
  background:white;
  border-radius:20px;
  padding:24px;
  border:1px solid #e8e6e0;
  max-width:850px;
  width:100%;
}

.field{
  margin-bottom:18px;
}

.label{
  display:block;
  margin-bottom:6px;
  font-size:13px;
  font-weight:600;
}

.input{
  width:100%;
  padding:13px 14px;
  border-radius:10px;
  border:1px solid #ddd;
  font-size:14px;
}

.btn{
  background:#2d2b69;
  color:white;
  border:none;
  border-radius:10px;
  padding:12px 18px;
  cursor:pointer;
  font-weight:600;
}

.row{
  display:flex;
  gap:12px;
}

.error{
  color:red;
  font-size:13px;
  margin-bottom:10px;
}

/* =========================
   PROFILE
========================= */

.profile-wrap{
  display:flex;
  align-items:center;
  margin:20px 0;
  gap:15px;
}

.profile-avatar{
  width:70px;
  height:70px;
  border-radius:50%;
  overflow:hidden;
  background:#ddd;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-shrink:0;
}

.profile-avatar img{
  width:100%;
  height:100%;
  object-fit:cover;
}

/* =========================
   RESPONSIVE
========================= */

@media(max-width:900px){

  .mobile-menu-btn{
    display:flex;
    position:fixed;
    top:14px;
    left:14px;
    width:42px;
    height:42px;
    border:none;
    border-radius:10px;
    background:#2d2b69;
    color:white;
    font-size:22px;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    z-index:1002;
  }

  .mobile-overlay{
    display:block;
    position:fixed;
    inset:0;
    background:rgba(0,0,0,0.45);
    opacity:0;
    pointer-events:none;
    transition:0.3s;
    z-index:998;
  }

  .mobile-overlay.show{
    opacity:1;
    pointer-events:auto;
  }

  .sidebar{
    transform:translateX(-100%);
    box-shadow:4px 0 20px rgba(0,0,0,0.2);
  }

  .sidebar.mobile-open{
    transform:translateX(0);
  }

  .main{
    margin-left:0;
    padding:72px 16px 24px;
  }

  .row{
    flex-direction:column;
  }

  .card{
    padding:18px;
    border-radius:16px;
  }

  .page-title{
    font-size:26px;
  }

  .profile-wrap{
    flex-direction:column;
    align-items:flex-start;
  }

  .btn{
    width:100%;
  }
}

@media(max-width:500px){

  .page-title{
    font-size:22px;
  }

  .input{
    font-size:13px;
    padding:12px;
  }

  .btn{
    padding:12px;
  }
}
  /* =========================
   SIDEBAR FOOTER
========================= */

.sidebar-footer{
  padding:16px 12px;
  border-top:1px solid rgba(255,255,255,0.1);
}

.user-row{
  display:flex;
  align-items:center;
  gap:10px;
}

.user-avatar{
  width:36px;
  height:36px;
  border-radius:10px;
  background:rgba(255,255,255,0.15);
  overflow:hidden;
  display:flex;
  align-items:center;
  justify-content:center;
  color:white;
  font-weight:700;
  flex-shrink:0;
}

.user-avatar img{
  width:100%;
  height:100%;
  object-fit:cover;
}

.user-name{
  font-size:13px;
  font-weight:600;
  color:white;
}

.user-plan{
  font-size:10px;
  color:rgba(255,255,255,0.45);
  margin-top:2px;
  letter-spacing:1px;
  text-transform:uppercase;
}

.logout-btn{
  width:100%;
  margin-top:14px;
  border:none;
  background:rgba(255,255,255,0.08);
  color:rgba(255,255,255,0.7);
  padding:10px;
  border-radius:10px;
  cursor:pointer;
  transition:0.2s;
  font-size:13px;
}

.logout-btn:hover{
  background:rgba(255,80,80,0.18);
  color:#ffb4b4;
}
`}</style>
<SuccessModal
  open={showSuccessModal}
  title="Profile Saved Successfully"
  message="Your profile saved sucessfully!"
  buttonText="View profile"
  onClose={() => {
    setShowSuccessModal(false);
    
  }}
/>
      <div className="shell">
        <>
  <button
    className="mobile-menu-btn"
    onClick={() =>
      setMobileMenu(!mobileMenu)
    }
  >
    ☰
  </button>

  <div
    className={`mobile-overlay ${
      mobileMenu ? "show" : ""
    }`}
    onClick={() =>
      setMobileMenu(false)
    }
  />
</>
        {/* SIDEBAR */}
        <aside
  className={`sidebar ${
    mobileMenu
      ? "mobile-open"
      : ""
  }`}
>
         <div className="logo">
  <div className="logo-title">
    Invoice AI
  </div>

  <div className="logo-sub">
    GST · AI · India
  </div>
</div>

<nav className="sidebar-nav">

  <Link
    to="/dashboard"
    className="nav-item"
  >
    ▦ Dashboard
  </Link>

  <Link
    to="/"
    className="nav-item"
  >
    ✨ WelcomePage
  </Link>

  <Link
    to="/invoices"
    className="nav-item"
  >
    📄 Invoices
  </Link>

  <Link
    to="/invoice/new"
    className="nav-item"
  >
    ＋ New Invoice
  </Link>

  <Link
    to="/invoice/ai"
    className="nav-item"
  >
    ✦ AI Generate
  </Link>

  <Link
    to="/settings"
    className="nav-item active"
  >
    ⚙ Settings
  </Link>

  <Link
    to="/billing"
    className="nav-item"
  >
    💳 Billing
  </Link>

</nav>
<div className="sidebar-footer">

  <div className="user-row">

    <div className="user-avatar">

      {user?.picture ? (

        <img
          src={user.picture}
          alt=""
          referrerPolicy="no-referrer"
        />

      ) : (

        (user?.name || "U")[0]
          .toUpperCase()

      )}

    </div>

    <div>

      <div className="user-name">
        {user?.name || "User"}
      </div>

      <div className="user-plan">
      {user?.plan+"Plan" || "Free Plan"}
      </div>

    </div>

  </div>

  <button
    className="logout-btn"
    onClick={handleLogout}
    disabled={loggingOut}
  >

    {loggingOut
      ? "Signing out..."
      : "Sign out"}

  </button>

</div>
        </aside>

        {/* MAIN */}
        <main className="main">
          <h1>Settings</h1>
          <p style={{ color: "#777" }}>Update your business profile</p>

          {/* PROFILE HEADER */}
          <div className="profile-wrap">
            <div
              style={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                overflow: "hidden",
                background: "#ddd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: 15
              }}
            >
              {profilePic ? (
                <img
                  src={profilePic}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              ) : (
                "👤"
              )}
            </div>

            <div>
              <div style={{ fontSize: 13, color: "#666" }}>Profile Completion</div>
              <div style={{ fontWeight: "bold", fontSize: 18 }}>{completion}%</div>

              <div style={{ width: 180, height: 8, background: "#eee", borderRadius: 10 }}>
                <div
                  style={{
                    width: `${completion}%`,
                    height: "100%",
                    background: "#2d2b69"
                  }}
                />
              </div>
            </div>
          </div>

          {/* CARD */}
          <div className="card">
            {error && <div className="error">{error}</div>}

            {/* GST */}
            <div className="field">
              <label className="label">GST Number</label>
              <div className="row">
                <input
                  className="input"
                  name="gstNumber"
                  value={form.gstNumber}
                  onChange={handleChange}
                />
                <button className="btn" onClick={fetchGST}>
                  {loading ? "Fetching..." : "Fetch"}
                </button>
              </div>
            </div>

            {/* BUSINESS NAME */}
            <div className="field">
              <label className="label">Business Name</label>
              <input className="input" name="businessName" value={form.businessName} onChange={handleChange} />
            </div>

            {/* CONTACT */}
            <div className="row">
              <div className="field" style={{ flex: 1 }}>
                <label className="label">Email</label>
                <input className="input" name="email" value={form.email} onChange={handleChange} />
              </div>

              <div className="field" style={{ flex: 1 }}>
                <label className="label">Phone</label>
                <input className="input" name="phone" value={form.phone} onChange={handleChange} />
              </div>
            </div>

            {/* ADDRESS */}
            <div className="field">
              <label className="label">Address</label>
              <input className="input" name="address" value={form.address} onChange={handleChange} />
            </div>

            {/* CITY STATE */}
            <div className="row">
              <div className="field" style={{ flex: 1 }}>
                <label className="label">City</label>
                <input className="input" name="city" value={form.city} onChange={handleChange} />
              </div>

              <div className="field" style={{ flex: 1 }}>
                <label className="label">State</label>
                <input className="input" name="state" value={form.state} onChange={handleChange} />
              </div>
            </div>

            {/* COUNTRY PIN */}
            <div className="row">
              <div className="field" style={{ flex: 1 }}>
                <label className="label">Country</label>
                <input className="input" name="country" value={form.country} onChange={handleChange} />
              </div>

              <div className="field" style={{ flex: 1 }}>
                <label className="label">Pincode</label>
                <input className="input" name="pincode" value={form.pincode} onChange={handleChange} />
              </div>
            </div>

              {/* LOGO UPLOADER */}
      <LogoUploader onUpload={handleLogoUpload} />


      {/* 👇 LIVE IMAGE PREVIEW HERE */}
      {preview && (
        <div style={{ marginTop: 20 }}>
          <p style={{ fontSize: 12, color: "#666" }}>
            Uploaded Logo Preview
          </p>

          <img
            src={preview}
            alt="logo"
            style={{
              width: 80,
              height: 80,
              objectFit: "cover",
              borderRadius: 12,
              border: "1px solid #ddd",
            }}
          />
        </div>
      )}

            {/* LOGO */}
            {/* <div className="field">
              <label className="label">Logo URL</label>
              <input className="input" name="logoUrl" value={form.logoUrl} onChange={handleChange} />
            </div>
             */}
<div className="field">
  <label className="label">Invoice Template</label>

  <select
    className="input"
    name="invoiceTemplate"
    value={form.invoiceTemplate}
    onChange={handleChange}
  >
    <option value="modern">Modern</option>
    <option value="classic">Classic</option>
    <option value="minimal">Minimal</option>
  </select>
</div>
            <button className="btn" onClick={saveSettings}>
              Save Settings
            </button>
          </div>
        </main>
      </div>
    </>
  );
}

export default Settings;